import { getEnvConfig } from "../config/api";
import { getAuthClient, AuthClientInstance } from "@trumpf/ux.utils";

const authClientServiceCalls: AuthClientInstance = getAuthClient();

/**
 * Request function to send an authenticated POST request to the PublicAPI
 * @param path path of the API endpoint without baseUrl
 * @param body object to send to the API (token is added automatically)
 * @returns Promise with the response of the API
 */
export const request = async function <T>(path: string, body?: object, overrideToken?: string): Promise<T> {
    if (authClientServiceCalls === null) {
        return Promise.reject("AuthClient not initialized");
    }
    const token = overrideToken || authClientServiceCalls.getAccessToken();
    if (!token) {
        return Promise.reject("No access token");
    }
    const { baseUrl } = getEnvConfig();
    return fetch(`${baseUrl}${path}`, {
        method: "POST",
        headers: {
            Accept: "application/json",
            "Content-Type": "application/json"
        },
        body: JSON.stringify({
            ...body,
            token
        })
    }).then(async (response) => {
        if (response.status === 401) {
            return Promise.reject("Unauthorized");
        }
        if (!response.ok) {
            const text = await response.text();
            return Promise.reject(text || `Request failed. Error code: ${response.status}.`);
        }
        return response.json();
    });
};

export const mockRequest = async function <T>(mockResponse: T): Promise<T> {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve(mockResponse);
        }, 1000);
    });
};
